import { t } from "ttag";

export interface RouteDefinition {
	path: string;
	formatLabel: () => string;
}

export const definitions = Object.freeze<Record<string, RouteDefinition>>({
	accountSettings: {
		path: "/account-settings",
		formatLabel: () => t`Account Settings`,
	},
	generalSettings: {
		path: "/general-settings",
		formatLabel: () => t`General Settings`,
	},
	checkoutDesign: {
		path: "/checkout-design",
		formatLabel: () => t`Checkout Design`,
	},
	placementDesign: {
		path: "/placement-design",
		formatLabel: () => t`Placement Design`,
	},
	accessKeys: {
		path: "/access-keys",
		formatLabel: () => t`Access Keys`,
	},
	emailNotifications: {
		path: "/email-notifications",
		formatLabel: () => t`Email Notifications`,
	},
	paymentProducts: {
		path: "/payment-products",
		formatLabel: () => t`Payment Products`,
	},
	internalSettings: {
		path: "/internal-settings",
		formatLabel: () => t`Internal Settings`,
	},
	bankInformation: {
		path: "/bank-information",
		formatLabel: () => t`Bank Information`,
	},
	fundingSettings: {
		path: "/funding-settings",
		formatLabel: () => t`Funding Settings`,
	},
	locationVerificationCodes: {
		path: "/location-verification-codes",
		formatLabel: () => t`Location Verification Codes`,
	},
	login: {
		path: "/login",
		formatLabel: () => t`Login`,
	},
	loginCallback: {
		// ED: This route shouldn't be modified without updating Okta's console
		path: "/implicit/callback",
		formatLabel: () => "",
	},
	logoutCallback: {
		path: "/logout/callback",
		formatLabel: () => "",
	},
	transactions: {
		path: "/transactions",
		formatLabel: () => t`Transactions`,
	},
	settlementReport: {
		path: "/settlement-report",
		formatLabel: () => t`Settlement Report`,
	},
	dataInsights: {
		path: "/data-insights",
		formatLabel: () => t`Data Insights`,
	},
	userManagement: {
		path: "/user-management",
		formatLabel: () => t`User Management`,
	},
	targetingExport: {
		path: "/targeting-export",
		formatLabel: () => t`Targeting Export`,
	},
	carts: {
		path: "/carts",
		formatLabel: () => t`Carts`,
	},
	cartsCreate: {
		path: "/carts/create",
		formatLabel: () => t`Create New Cart`,
	},
	cartsViewEdit: {
		path: "/carts/:cartId",
		formatLabel: () => t`View or Edit Cart`,
	},
	locations: {
		path: "/locations",
		formatLabel: () => t`Locations`,
	},
	merchantUserActivation: {
		path: "/activate/:activationToken",
		formatLabel: () => t`Activate`,
	},
	resetPassword: {
		path: "/password/reset/:activationToken",
		formatLabel: () => t`Reset Your Password`,
	},
	merchantIdValidation: {
		path: "/merchant-id-validation",
		formatLabel: () => t`Merchant ID Validation`,
	},
});

export const routes = {
	accountSettings: definitions.accountSettings.path,
	generalSettings: definitions.generalSettings.path,
	checkoutDesign: definitions.checkoutDesign.path,
	placementDesign: definitions.placementDesign.path,
	accessKeys: definitions.accessKeys.path,
	emailNotifications: definitions.emailNotifications.path,
	paymentProducts: definitions.paymentProducts.path,
	internalSettings: definitions.internalSettings.path,
	bankInformation: definitions.bankInformation.path,
	fundingSettings: definitions.fundingSettings.path,
	userManagement: definitions.userManagement.path,
	targetingExport: definitions.targetingExport.path,
	dataInsights: definitions.dataInsights.path,
	settlementReport: definitions.settlementReport.path,
	transactions: definitions.transactions.path,
	carts: definitions.carts.path,
	cartsCreate: definitions.cartsCreate.path,
	cartsViewEdit: definitions.cartsViewEdit.path,
	locations: definitions.locations.path,
	loginCallback: definitions.loginCallback.path,
	logoutCallback: definitions.logoutCallback.path,
	login: definitions.login.path,
	merchantUserActivation: definitions.merchantUserActivation.path,
	resetPassword: definitions.resetPassword.path,
	locationVerificationCodes: definitions.locationVerificationCodes.path,
	merchantIdValidation: definitions.merchantIdValidation.path,
};

export const HomePageRoute = routes.transactions;
